import script from "./HeaderBody.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderBody.vue?vue&type=script&setup=true&lang=js"

import "./HeaderBody.vue?vue&type=style&index=0&id=1b2f8ead&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b2f8ead"]])

export default __exports__